module.exports = __webpack_public_path__ + "img/mrbts-banner.8f49702b.jpg";